import ParticipantsModal from './ParticipantsModal';

export default ParticipantsModal;
